import { useLingui } from "@lingui/react/macro";
import type { ShelfLifeUnit } from "@/types/recipe";

/** The units a shelf life can be measured in (T-1004). Hours first, because it
 * is the case the old days-only field could not express. */
export const SHELF_LIFE_UNIT_KEYS: readonly ShelfLifeUnit[] = ["HOURS", "DAYS"];

export function useShelfLifeUnitNames(): Record<ShelfLifeUnit, string> {
  const { t } = useLingui();
  return { HOURS: t`Hours`, DAYS: t`Days` };
}

/**
 * The shelf-life half of a save payload.
 *
 * Both fields travel together: an empty box clears the unit too, so no stage is
 * left holding a "HOURS" with nothing to count, and the server — which rejects
 * exactly that — never has to (T-1004).
 */
export function shelfLifePayload(
  value: string,
  unit: ShelfLifeUnit,
): { shelfLifeValue: number | null; shelfLifeUnit: ShelfLifeUnit | null } {
  if (value.trim() === "") return { shelfLifeValue: null, shelfLifeUnit: null };
  return { shelfLifeValue: Number(value), shelfLifeUnit: unit };
}
